import React, { useState } from "react";
import { Mail, MapPin, Clock } from "lucide-react";
import { IMAGES } from "@/data/site";
import { sendContact } from "@/lib/api";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "Demande générale", message: "" });
  const [msg, setMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMsg(null);
    try {
      const res = await sendContact(form);
      setMsg({ type: "success", text: res.message });
      setForm({ name: "", email: "", subject: "Demande générale", message: "" });
    } catch (err) {
      setMsg({ type: "error", text: "Une erreur est survenue. Réessayez." });
    }
    setLoading(false);
  };

  return (
    <>
      <PageHero
        tag="Service client"
        title="Nous <em>contacter</em>"
        subtitle="Une question, un conseil personnalisé ? Notre équipe vous répond en moins de 24h."
        image={IMAGES.contactHero}
      />
      <Breadcrumb trail={[{ label: "Accueil", to: "/" }, { label: "Contact" }]} />

      <div className="cart-layout" data-testid="contact-page">
        <div>
          <h2 className="section-title" style={{ marginBottom: "1.5rem" }}>Écrivez-nous</h2>
          {msg ? <div className={`form-msg ${msg.type}`} data-testid="contact-msg">{msg.text}</div> : null}
          <form onSubmit={onSubmit} data-testid="contact-form">
            <div className="form-field">
              <label htmlFor="name">Nom complet</label>
              <input id="name" name="name" required value={form.name} onChange={onChange} data-testid="contact-name" />
            </div>
            <div className="form-field">
              <label htmlFor="email">Email</label>
              <input id="email" name="email" type="email" required value={form.email} onChange={onChange} data-testid="contact-email" />
            </div>
            <div className="form-field">
              <label htmlFor="subject">Sujet</label>
              <select id="subject" name="subject" value={form.subject} onChange={onChange} data-testid="contact-subject">
                <option>Demande générale</option>
                <option>Conseil produit / diagnostic de peau</option>
                <option>Suivi de commande</option>
                <option>Retour & remboursement</option>
                <option>Partenariat / presse</option>
              </select>
            </div>
            <div className="form-field">
              <label htmlFor="message">Message</label>
              <textarea id="message" name="message" rows={6} required value={form.message} onChange={onChange} data-testid="contact-message" />
            </div>
            <button type="submit" className="btn-primary" style={{ width: "100%" }} disabled={loading} data-testid="contact-submit">
              {loading ? "Envoi en cours…" : "Envoyer le message"}
            </button>
          </form>
        </div>

        <aside className="cart-summary" style={{ position: "static" }}>
          <h3>Coordonnées</h3>
          <p style={{ display: "flex", gap: "0.6rem", alignItems: "flex-start", marginBottom: "1rem", fontSize: "0.85rem" }}>
            <Mail size={16} color="var(--gold)" /> contact@nerolyacosmetic.com
          </p>
          <p style={{ display: "flex", gap: "0.6rem", alignItems: "flex-start", marginBottom: "1rem", fontSize: "0.85rem" }}>
            <MapPin size={16} color="var(--gold)" /> Rue des Artisans 12, 1000 Bruxelles, Belgique
          </p>
          <p style={{ display: "flex", gap: "0.6rem", alignItems: "flex-start", fontSize: "0.85rem" }}>
            <Clock size={16} color="var(--gold)" /> Lun–Ven · 9h–18h (réponse sous 24h)
          </p>
        </aside>
      </div>
    </>
  );
}
